import { __extends } from "tslib";
import * as React from 'react';
import { config } from '../../config';
import { ErrorPageContainer } from '../error-page/error-page-container';
import { ErrorPageType } from '../..';
var ErrorBoundry = /** @class */ (function (_super) {
    __extends(ErrorBoundry, _super);
    function ErrorBoundry(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isError: false,
        };
        return _this;
    }
    ErrorBoundry.prototype.componentDidCatch = function (error) {
        this.setState({ isError: true });
        config.sentryClient && config.sentryClient.captureException(error);
    };
    ErrorBoundry.prototype.componentDidUpdate = function (prevProps) {
        prevProps !== this.props && this.setState({ isError: false });
    };
    ErrorBoundry.prototype.render = function () {
        if (this.state.isError) {
            return (this.props.fallback || (React.createElement(ErrorPageContainer, { errorPageType: ErrorPageType.INTERNAL_SERVER })));
        }
        return this.props.children;
    };
    return ErrorBoundry;
}(React.Component));
export { ErrorBoundry };
//# sourceMappingURL=error-boundry.js.map